<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.js-clear-cart');
  if (!btn) return;
  e.preventDefault();

  const msg = btn.dataset.confirm || 'Remove all items from your cart?';
  if (!confirm(msg)) return;
  btn.disabled = true;

  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error('Clear failed: ' + res.status);
    window.location.reload();
  } catch (err) {
    console.error('Clear cart failed:', err);
    btn.disabled = false;
  }
});
console.log('custom.js loaded');